import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BrowserEventsConstants } from 'src/app/models/constants/browserEvents.constants';

@Injectable({
  providedIn: 'root'
})

export class WindowResizeHelper {

  private windowWidthSubject: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);

  constructor() {
    
    this.listenToWindowResize();
  }

  private listenToWindowResize() {
    
    window.addEventListener(BrowserEventsConstants.WINDOW_RESIZE, this.onResize.bind(this));
  }

  private onResize() {

    this.windowWidthSubject.next(window.innerWidth);
  }

  getWindowWidth(): Observable<number> {

    return this.windowWidthSubject.asObservable();
  }
}
